/**
 * Basic TupasPage
 * Redirects when using HTML5 history api to the provided url.
 */
import {
    getProviders,
    startLoadingTupasProviders,
    IProvidersResponse,
    ITupasLoadProperties,
} from "../../ducks/tupas";
import { ReduxDispatch, ReduxState } from "../../ducks/reducers";
import { connect } from "react-redux";
import React from "react";
import { RouteComponentProps } from "react-router";
import { Typography, Grid } from "material-ui";
import { Error } from "material-ui-icons";
import { SetHeader, SetShowBackNavigation } from "../../ducks/common";

/**
 * Props provided by redux
 */
interface ITupasPageStateProps {
    tupasData: IProvidersResponse | null;
}

/**
 * Props provided by route component
 */
interface ITupasPageRouteProps {
    requestType?: number;
}

/**
 * Dispatch functions provided by redux
 */
interface ITupasPageDispatchProps {
    SetHeaderValue: (header: string) => void;
    LoadProviderData: (
        redirectProps: ITupasLoadProperties,
        requestType?: number
    ) => Promise<void>;
    ShowBackNavigation: () => void;
    HideBackButton: () => void;
}

interface TupasState {
    isInAppBrowserOpen: boolean;
    redirect: boolean;
    routeParams: string;
    error: boolean;
    return: boolean;
    loading: boolean;
}
/**
 * Combined properties of the component
 */
type ITupasPageProps = ITupasPageStateProps &
    ITupasPageDispatchProps &
    RouteComponentProps<ITupasPageRouteProps>;

class TupasPage extends React.Component<ITupasPageProps, TupasState> {
    constructor(props: ITupasPageProps) {
        super(props);
        this.state = {
            isInAppBrowserOpen: false,
            redirect: false,
            error: false,
            return: false,
            routeParams: "",
            loading: true,
        };
    }

    componentDidMount() {
        this.props.SetHeaderValue("Tunnistautuminen");
        //this.props.ShowBackNavigation();
    }

    componentWillUnmount() {
        this.props.SetHeaderValue("");
        this.props.HideBackButton();
    }

    public render() {
        return (
            <div className="tupas-page">
                <div
                    style={{
                        display: "flex",
                        flexWrap: "wrap",
                        alignItems: "center",
                    }}
                >
                    <Grid container spacing={0} justify="center">
                        <Grid item xs={12} sm={10} md={6}>
                            <Grid
                                item
                                xs={12}
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    marginBottom: 16,
                                }}
                            >
                                <Error style={{ textAlign: "center" }} />
                            </Grid>
                            <Typography
                                variant="body2"
                                color="inherit"
                                align="center"
                            >
                                Päivitä sovelluksesi uuteen versioon.
                            </Typography>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: ReduxState): ITupasPageStateProps => {
    return {
        // ...mapStateToProps
        tupasData: getProviders(state),
    };
};

const mapDispatchToProps = (
    dispatch: ReduxDispatch
): ITupasPageDispatchProps => {
    return {
        // ...mapDispatchToProps
        SetHeaderValue: (header) => {
            return dispatch(SetHeader(header));
        },
        LoadProviderData: (
            redirectProps: ITupasLoadProperties,
            requestType?: number
        ) => {
            return dispatch(
                startLoadingTupasProviders(redirectProps, requestType)
            );
        },
        ShowBackNavigation: () => {
            return dispatch(SetShowBackNavigation(true));
        },
        HideBackButton: () => {
            dispatch(SetShowBackNavigation(false));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TupasPage);



// WEBPACK FOOTER //
// ./src/views/tupas/TupasPage.tsx